import { Component, OnInit, Input } from '@angular/core';
import { TutorialService } from '../../_services/tutorial.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-watch-tutorial',
  templateUrl: './watch-tutorial.component.html',
  styleUrls: ['./watch-tutorial.component.css']
})
export class WatchTutorialComponent implements OnInit {
  public routeName: string = '';
  public tutorialLink: string = '';
  public tutorial: any = [];

  constructor(private tutorialService: TutorialService,
    private router: Router
  ) { }

  ngOnInit() {
    this.routeName = this.router.url.split('?')[0] || '';
    this.tutorialService.getTutorials().subscribe(response => {
      const responseData = response.data;
      if (responseData.tutorials) {
        const tutorials = JSON.parse(responseData.tutorials);
        const tutorial = tutorials.find(t => t.route === this.routeName);
        if (tutorial) {
          this.tutorialLink = tutorial.link;
          this.tutorial = tutorial;
        }
      }
    });
  }

  watchTutorial(tutorialLink: string) {
    if (tutorialLink) {
      window.open(tutorialLink, '_blank');
    }
  }
  

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-master/watch-tutorial/watch-tutorial.component.ts